import { LocaleDict } from "@/i18n";
import { ComputeFieldComponent } from "../../computeFields";

export const InscriptionDosCF: ComputeFieldComponent<{
  inscription: LocaleDict<string>;
}> = ({ input, lineBreak = false, language }) => {
  const inscription = input.inscription[language] ?? "";

  return (
    <>
      {inscription}
      {inscription && lineBreak && <br />}
    </>
  );
};
